import axios from "axios";

export default axios.create({
  baseURL: `https://fng-user-service.herokuapp.com/api/user`,
});
